<template>
  <w-modal
    v-model="show"
    :title="$t('modals.players-add')"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    :submit-button="$t('buttons.add')"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-md-12">
        <w-input :model="$schema.profile.firstName" :title="$t($schema.profile.firstName.$schema.title)" />
      </div>

      <div class="form-group col-md-12">
        <w-input :model="$schema.profile.lastName" :title="$t($schema.profile.lastName.$schema.title)" />
      </div>

      <div class="form-group col-md-12">
        <w-input :model="$schema.profile.phoneNumber" :title="$t($schema.profile.phoneNumber.$schema.title)" />
      </div>

      <div class="form-group col-md-12">
        <form-datepicker :model="$schema.profile.birthDate" :title="$t($schema.profile.birthDate.$schema.title)" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/player.schema';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({
  profile: {
    lang: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    birthDate: ''
  },
  teamId: null
});

// @vuese
// Modal dodawania zawodnika do grupy treningowej
// @group Team
export default {
  mixins: [manageMixin('team', {}, emptyData)],
  schema,
  methods: {
    // @vuese
    // Funkcja waliduje formularz
    save() {
      this.$schema.teamId.$model = tryParseInt(this.$route.params.teamId);
      this.$schema.$setData({
        profile: { lang: localStorage.getItem(Storage.LANG) || process.env.VUE_APP_I18N_LOCALE }
      });

      if (!this.$schema.$validateAll().length) {
        this.$emit('save', this.$schema.$getData());
        this.$schema.$setDefault();
        this.close();
      } else {
        this.notifyError('messages.form.error');
      }
    }
  }
};
</script>
